export const TypeOfPeriod = Object.freeze({
    Range: 0,
    Forever: 1,
    None: 2,
});
